import { Directive, Input, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { BrandsState, brandUuid } from 'src/app/core/store/brands';

@Directive({
  selector: '[appShowForBrand]',
})
export class ShowForBrandDirective implements OnInit {
  condition: boolean;
  @Input() set appShowForBrand(condition: boolean) {
    this.condition = condition;
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private store: Store<BrandsState>
  ) {}

  ngOnInit() {
    this.checkForBrand();
  }

  checkForBrand() {
    this.store.pipe(select(brandUuid)).subscribe((brandUuid) => {
      if (
        (brandUuid !== undefined && this.condition) ||
        (!brandUuid && !this.condition)
      ) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      } else {
        this.viewContainer.clear();
      }
    });
  }
}
